if (!customElements.get('sticky-cart')) {
  class StickyCart extends HTMLElement {
    constructor() {
      super();

      this.container = this;
      this.buttonTrigger = this.container.querySelector('.sticky-cart__action button');
      this.svgCartIcon = `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-cart" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M4.5 8.01995L8.52569 3.62829C9.31836 2.76355 10.6816 2.76355 11.4743 3.62829L15.5 8.01995M17.5975 9.31685L15.4243 16.3168C15.2944 16.7352 14.9073 17.0204 14.4693 17.0204H5.58499C5.14911 17.0204 4.76345 16.738 4.63173 16.3225L2.41278 9.32253C2.2084 8.67779 2.68968 8.02035 3.36603 8.02035H16.6425C17.3163 8.02035 17.7973 8.67329 17.5975 9.31685Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>`      

      this.hasScrolledPastOnce = false;
      this.isVisible = false;
      
      this.bindEventHandlers();
    }

    connectedCallback() {
      this.handleDOMContentLoaded();
      this.handleOptionsLink();
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }

    bindEventHandlers() {
      this.onDOMContentLoaded = this.handleDOMContentLoaded.bind(this);
      this.onOptionsLink = this.handleOptionsLink.bind(this);
      this.addToCart = this.handleAddToCart.bind(this);
      this.waitForButtonState();
    }

    removeEventListeners() {
      if (this.observer) this.observer.disconnect();
      this.onDOMContentLoaded = null;
      this.onOptionsLink = null;
      this.addToCart = null;
    }

    handleDOMContentLoaded() {
      if (this.observer) this.observer.disconnect();

      this.targetEl = document.querySelector('form[data-type=add-to-cart-form]');
      if (!this.targetEl) return;

      this.observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (!entry) return;

        const isVisible = entry.isIntersecting;
        
        if (!isVisible) {
          if (this.buttonTrigger.children.length > 0) {
            this.container.classList.add('sticky-cart--open');
          }
        } else {
          this.container.classList.remove('sticky-cart--open');
        }
      }, {
        threshold: [0, 0.1],
        rootMargin: "0px 0px 0px 0px"
      });

      this.observer.observe(this.targetEl);
    }

    handleOptionsLink() {
      const link = this.querySelector('.sticky-cart__action--link');
      if (link) {
        link.addEventListener('click', () => {
          let targetEl = document.querySelector('.product__info-container variant-selects') 
          || document.querySelector('.product__info-container variant-radios') 
          || document.querySelector('.product__info-container product-form')

          targetEl?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    }

    async waitForButtonState() {
      const preorderPromise = this.waitForElement('.essential-preorder-container-active', 4000);
      const avpPromise = this.waitForElement('#avpoptions-container__v2', 4000);

      try {
        const isOnlyDefaultVariant = this.buttonTrigger?.getAttribute('data-only-default-variant') === 'true';

        const [preorderEl, avpEl] = await Promise.all([
          preorderPromise,
          avpPromise
        ]);

        let result;

        if (preorderEl) {
          result = { 
            type: 'link', 
            label: preorderEl.querySelector('.essential-preorder-initial-add-to-cart-text span')?.textContent || 'Order Now (Made To Order)', 
            showCartIcon: false 
          };
        } 
        else if (avpEl) {
          result = { 
            type: 'link', 
            label: 'Add To Cart', 
            showCartIcon: true 
          };
        } 
        else {
          result = {
            type: isOnlyDefaultVariant ? 'action' : 'link',
            label: 'Add To Cart',
            showCartIcon: true
          };
        }

        this.setButtonLogic(result.type, result.label, result.showCartIcon);

      } catch (err) {
        console.error('Button state error:', err);
        this.setButtonLogic('link', 'Add To Cart', true);
      }
    }

    waitForElement(selector, timeout = 4000) {
      return new Promise((resolve) => {
        const element = document.querySelector(selector);
        if (element) {
          resolve(element);
          return;
        }

        const observer = new MutationObserver(() => {
          const el = document.querySelector(selector);
          if (el) {
            observer.disconnect();
            resolve(el);
          }
        });

        observer.observe(document.body, { 
          childList: true, 
          subtree: true 
        });

        setTimeout(() => {
          observer.disconnect();
          resolve(null);
        }, timeout);
      });
    }

    setButtonLogic(trigger, label, showCartIcon = false){
      if(trigger == 'link'){
        this.buttonTrigger.insertAdjacentHTML(
          'beforeend',
          `<span>
            ${label}
            ${showCartIcon ? this.svgCartIcon : ''}
          </span>`
        );
        this.buttonTrigger.classList.add('sticky-cart__action--link');
        this.handleOptionsLink();
        
      }else{
        this.buttonTrigger.insertAdjacentHTML(
          'beforeend',
          `<span>
            ${label}
            ${showCartIcon ? this.svgCartIcon : ''}
          </span>`
        );
        this.buttonTrigger.classList.add('sticky-cart__action--add');
        this.handleAddToCart();
      }

      if(!this.isVisible && !this.container.classList.contains('sticky-cart--open')){
        this.container.classList.add('sticky-cart--open');
      }
    }

    handleAddToCart() {
      this.buttonTrigger.addEventListener('click', () => {
        if (this.buttonTrigger.getAttribute('aria-disabled') === 'true') return;

        this.buttonTrigger.setAttribute('aria-disabled', true);

        document.querySelector('.product__info-container .product-form__submit[type=submit]').click();

        setTimeout(() => {
          this.buttonTrigger.setAttribute('aria-disabled', false);
        }, 1000);
      });
    }
  }

  customElements.define('sticky-cart', StickyCart);
}